import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import break_box from '../../../../images/product/break_box.png';

import axios from "axios";

const Package_Price_List = ({ show, onClose }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // page table data fetch
    const fetchData = () => {
        
        axios.get(`${baseURL}/manage-package`)
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // fetch data
    useEffect(() => {
        fetchData();
    }, []);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const tableRef = useRef(null);
    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        paging: false,
                        scrollY: "250px", // Set the scroll height here
                        scrollCollapse: true,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    
    return (
        <Modal show={show} size="xl"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Package Price List</h3>
                    <Button variant="" type="button" className="close px-6 py-1" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="table-container">
                        <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th>Package</th>
                                    <th>Products</th>
                                    <th>Timeline</th> 
                                    <th>Oneday Amount</th>
                                    <th>Selling Amount</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {datas.map((data, index) => (
                                    <tr key={data.sno}>
                                        <td>
                                            <label className='text-black font-w400 fs-7 text-wrap mw-200px'>{data.package_name}</label>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={data.product_image || break_box} className='border rounded px-1 py-0'>
                                                        <img src={data.product_image || break_box} alt={data.product_name} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>{data.product_name}</label>
                                                    <div className="d-block">
                                                        <label className="fs-8 text-dark font-w600">{data.product_category_name}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>
                                                {data.timeline_details?.packagetimeline_name || 'N/A'} 
                                                {data.timeline_details?.days ? `(${data.timeline_details.days} Days)` : 'No Days'}
                                            </label>
                                            <div className="d-block">
                                                <label className="fs-8 text-dark font-w600">
                                                    {data.timeline_details?.all_days === 0
                                                        ? ' (All Days)'
                                                        : (() => {
                                                            // Define the days of the week
                                                            const daysOfWeek = [
                                                                { key: 'sunday', label: 'Sun' },
                                                                { key: 'monday', label: 'Mon' },
                                                                { key: 'tuesday', label: 'Tue' },
                                                                { key: 'wednesday', label: 'Wed' },
                                                                { key: 'thursday', label: 'Thu' },
                                                                { key: 'friday', label: 'Fri' },
                                                                { key: 'saturday', label: 'Sat' },
                                                            ];

                                                            // Filter the selected days (where day is marked as '1')
                                                            const selectedDays = daysOfWeek.filter(day => data.timeline_details[day.key] === '0')
                                                                                        .map(day => day.label); // Map to only the day labels

                                                            // If no days are selected
                                                            if (selectedDays.length === 0) {
                                                                return ' 0 details';
                                                            }

                                                            // Join the selected days with a comma and return it
                                                            return ` (${selectedDays.join(', ')})`;
                                                        })()
                                                    }
                                                </label>
                                            </div>
                                        </td>
                                         <td>
                                            <label className='text-red font-w600 fs-7'>
                                                <span><i class="fa-solid fa-indian-rupee-sign  me-2"></i></span>
                                                <span>{new Intl.NumberFormat('en-IN').format(data.product_amount)}</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label className='text-red font-w600 fs-7'>
                                                <span><i class="fa-solid fa-indian-rupee-sign  me-2"></i></span>
                                                <span>{new Intl.NumberFormat('en-IN').format(data.selling_amount)}</span>
                                            </label>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Package_Price_List;
